import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Pagination } from 'react-bootstrap';
//import * as model from 'models/Models';
import { LinkContainer } from 'react-router-bootstrap'
import { PaginationInfoMetadata } from 'models';

const PaginationItem = Pagination.Item;

interface IPaginationProps {
  metaData: PaginationInfoMetadata;
  queryParameter?: string | undefined;
}

function generatePagerLink(queryParameter: string, page: number) {
  const [currentSearchParams] = useSearchParams({});
  var searchParams = new URLSearchParams(currentSearchParams);
  if (page > 0) {
    searchParams.set(queryParameter, page.toString());
  } else {
    searchParams.delete(queryParameter);
  }
  const paramsString = searchParams.toString();
  if (paramsString) {
    //return "?" + paramsString;
    return {search: paramsString};
  }
  //return "?";
  return {search: ""};
}

const Pager = (props: IPaginationProps) => {
  //props.metaData.page
  const qp = props.queryParameter || "p";
  const page = props.metaData.page;
  if (props.metaData.noPages < 1)
    return <></>;

  return (
    <Pagination aria-label="Page navigation example">
      <LinkContainer isActive={() => false} to={generatePagerLink(qp, 0)}>
        <Pagination.Item disabled={page === 0}>Första</Pagination.Item>
      </LinkContainer>

      <LinkContainer isActive={() => false} to={generatePagerLink(qp, page - 1)}>
        <Pagination.Item disabled={page < 1}>
          Föregående
        </Pagination.Item>
      </LinkContainer>

      <Pagination.Item disabled={true}>{page + 1}&nbsp;/&nbsp;{props.metaData.noPages}</Pagination.Item>

      <LinkContainer isActive={() => false} to={generatePagerLink(qp, page + 1)}>
        <Pagination.Item disabled={page >= props.metaData.noPages - 1}>
          Nästa
        </Pagination.Item>
      </LinkContainer>

      <LinkContainer isActive={() => false} to={generatePagerLink(qp, props.metaData.noPages - 1)}>
        <Pagination.Item disabled={page >= props.metaData.noPages - 1}>
          Sista
        </Pagination.Item>
      </LinkContainer>

      {/* <PaginationItem active={false} disabled={true}>
        <PaginationLink disabled={true}>{page + 1} / {props.metaData.noPages}</PaginationLink>
      </PaginationItem>
      <PaginationItem disabled={page >= props.metaData.noPages - 1}>
        <PaginationLink tag={Link} next to={generatePagerLink(qp, page + 1)} >Next</PaginationLink>
      </PaginationItem>
      <PaginationItem disabled={props.metaData.page >= props.metaData.noPages - 1}>
        <PaginationLink tag={Link} last to={generatePagerLink(qp, noPages - 1)}>Last</PaginationLink>
      </PaginationItem> */}
    </Pagination>
  );
}

export default Pager;
